"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridColumnResizePlugin = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("../../helpers/constants");
const GridHeaderCellWithResizeTrigger_1 = require("./components/GridHeaderCellWithResizeTrigger/GridHeaderCellWithResizeTrigger");
const GridResizeIndicator_1 = require("./components/GridResizeIndicator/GridResizeIndicator");
const getMaxContentSize_1 = require("./helpers/getMaxContentSize");
function gridColumnResizePlugin(config) {
    return ({ rootRef, getColumns }) => {
        let rootLeftOffset = 0;
        let startPosition = 0;
        return {
            processColumns: (originalColumns) => {
                return originalColumns.map((column) => {
                    return Object.assign(Object.assign({}, column), { header: (props) => {
                            return (react_1.default.createElement(GridHeaderCellWithResizeTrigger_1.GridHeaderCellWithResizeTrigger, { onDragStart: ({ x }) => {
                                    var _a, _b, _c, _d, _e, _f;
                                    startPosition = x;
                                    rootLeftOffset =
                                        (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) !== null && _b !== void 0 ? _b : 0;
                                    (_d = (_c = rootRef.current) === null || _c === void 0 ? void 0 : _c.style) === null || _d === void 0 ? void 0 : _d.setProperty('--grid-core-resize-indicator-left-position', `${x - rootLeftOffset}px`);
                                    (_f = (_e = rootRef.current) === null || _e === void 0 ? void 0 : _e.style) === null || _f === void 0 ? void 0 : _f.setProperty('--grid-core-resize-indicator-display', 'block');
                                }, onDragEnd: ({ x }) => {
                                    var _a, _b, _c;
                                    const resizeDelta = x - startPosition;
                                    (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty('--grid-core-resize-indicator-display', 'none');
                                    if (resizeDelta === 0) {
                                        return;
                                    }
                                    const allSizes = getColumns().reduce((acc, curr) => {
                                        acc[curr.id] = curr.width || constants_1.MIN_COLUMN_WIDTH;
                                        if (curr.id === props.column.id) {
                                            acc[curr.id] = Math.max(props.column.width + resizeDelta, constants_1.MIN_COLUMN_WIDTH);
                                        }
                                        return acc;
                                    }, {});
                                    (_c = config.onResize) === null || _c === void 0 ? void 0 : _c.call(config, allSizes);
                                }, onMouseMove: ({ x }) => {
                                    var _a, _b;
                                    (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty('--grid-core-resize-indicator-left-position', `${x - rootLeftOffset}px`);
                                }, onDoubleClick: () => __awaiter(this, void 0, void 0, function* () {
                                    var _a;
                                    try {
                                        const maxContentWidth = yield (0, getMaxContentSize_1.getMaxContentSize)(props.column.id, rootRef).then((result) => result + 1);
                                        const allSizes = getColumns().reduce((acc, curr) => {
                                            if (curr.id === props.column.id) {
                                                acc[curr.id] = Math.max(constants_1.MIN_COLUMN_WIDTH, Math.min(maxContentWidth, column.maxWidth || maxContentWidth));
                                            }
                                            return acc;
                                        }, {});
                                        (_a = config.onResize) === null || _a === void 0 ? void 0 : _a.call(config, allSizes);
                                    }
                                    catch (error) {
                                        console.error(`Error of maxContentWidth calculation: ${error}`);
                                    }
                                }) }, column.header(props)));
                        } });
                });
            },
            containerAddons: [
                {
                    id: 'resizeIndicator',
                    order: 99,
                    render: () => react_1.default.createElement(GridResizeIndicator_1.GridResizeIndicator, null)
                }
            ]
        };
    };
}
exports.gridColumnResizePlugin = gridColumnResizePlugin;
//# sourceMappingURL=gridColumnResizePlugin.js.map